<div class="height-100 gray-bg recomendacoes-semeadura">
  <div class="wrapper wrapper-content">
    <div class="ibox">
      <div class="ibox-title">
        <h2>Recomendação de Semeadura</h2>
        <div class="ibox-tools" ng-if="$root.permissions.recomendacaoSemeadura.canManage">
          <a href="#!/recomendacao_semeadura" class="btn btn-primary">
            <i class="fa fa-plus"></i>
            Novo
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-xs-5">
            <div class="form-horizontal">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Filtros</h3>
                </div>
              </div>
              <div class="form-group">
                <label for="safra" class="control-label col-xs-4">Safra:</label>
                <div class="col-xs-8">
                  <select name="safra" id="safra" ng-options="safra.descricao for safra in recs.safras track by safra.id" ng-model="recs.filters.safra" class="form-control"></select>
                </div>
              </div>
              <div class="form-group">
                <label for="status" class="control-label col-xs-4">Status:</label>
                <div class="col-xs-8">
                  <select name="status" id="status" ng-model="recs.filters.status" class="form-control">
                    <option value="">Todos</option>
                    <option value="rascunho">Rascunho</option>
                    <option value="aprovado">Aprovado</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 text-right">
                  <button type="button" class="btn btn-info" ng-click="recs.loadList()">
                    Filtrar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
          </div>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Data Início</th>
              <th>Cultura</th>
              <th>Recomendante</th>
              <th>Talhões</th>
              <th>Situação</th>
              <th colspan="2">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="rec in recs.recommendations track by rec.id">
              <td>{{::rec.id}}</td>
              <td>{{::rec.data_inicio | date:'dd/MM/yyyy'}}</td>
              <td>{{::rec.cultura.descricao}}</td>
              <td>{{::rec.usuario.nome_completo | capitalize}}</td>
              <td>{{::rec.glebas | getTextItems:'descricao' | capitalize}}</td>
              <td>
                {{::rec.situacao | capitalize}}

                <i class="icon-info text-muted"
                  ng-if="rec.progress"
                  uib-tooltip-template="'tooltip-em-andamento.html'"
                  tooltip-placement="left"
                  tooltip-class="tooltip-em-andamento"
                  tooltip-append-to-body="true"
                  tooltip>
                </i>

                <br>

                <a ng-click="recs.loadStatus(rec)" ng-if="recs.showDetailsBtn(rec)"><small>Detalhes</small></a>
                <p class="text-cinza" ng-show="rec.loading">
                  <small>
                    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
                  </small>
                </p>
                <div ng-if="rec.progress">
                  <div class="progress">
                    <div class="progress-bar" ng-style="recs.percentWidth(rec.progress.percentual)" style="min-width: 2em;">
                      {{rec.progress.percentual * 100 | number:0}}%
                    </div>
                  </div>
                  <p class="text-right"><small>{{rec.progress.aplicada | number:1}}ha de {{rec.progress.recomendada | number:1}}ha</small></p>
                </div>
              </td>
              <td>{{::rec.status | capitalize}}</td>
              <td class="action-column">
                <a ng-href="#!/recomendacao_semeadura/{{::rec.id}}?printRecomedacao=true" class="btn btn-link" >
                  <i class="fa fa-print"></i>
                </a>
                <div class="btn-group" ng-if="$root.permissions.recomendacaoSemeadura.canManage">
                  <a ng-href="#!/recomendacao_semeadura/{{::rec.id}}" class="btn btn-primary">
                    <i class="fa fa-edit"></i>
                    Editar
                  </a>
                  <button type="button" class="btn btn-danger" ng-click="recs.confirmDelete(rec)">
                    <i class="fa fa-trash"></i>
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-include src="'views/_pagination.html'"></ng-include>
      </div>
    </div>
  </div>
</div>

<script type="text/ng-template" id="tooltip-em-andamento.html">
  <div class="text-justify">
    <h4>Plantios já realizados</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Talhão</th>
          <th class="text-center">Recomendado (ha)</th>
          <th class="text-center">Realizado (ha)</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="info in rec.progress.glebas | orderBy:'gleba.descricao' track by info.gleba.id">
          <td>{{info.gleba.descricao}}</td>
          <td class="text-center">{{info.area_recomendada | number:1}}</td>
          <td class="text-center">{{info.area_aplicada | number:1}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</script>
